import { Api } from '../api';
import { accounts } from '../endpoints';
import type { AddAccountRequest, GetAccountsResponse, GetAllTransactionsResponse, GetTransactionsResponse } from './models';

export class AccountsApi extends Api {
  static getAccounts = (signal?: AbortSignal) => this.get<GetAccountsResponse[]>(accounts.account(), { signal });

  static getTransactions = (id: string, signal?: AbortSignal) => this.get<GetTransactionsResponse[]>(accounts.transactions(id), { signal });

  static getAllTransactions = (id: string, signal?: AbortSignal) => this.get<GetAllTransactionsResponse[]>(accounts.allTransactions(id), { signal });

  static addAccount = (request: AddAccountRequest, signal?: AbortSignal) =>
    this.post<null>(accounts.account(), request, { responseType: 'none', signal });
}
